export default __webpack_public_path__ + "static/Innovation-Lab-2ae4633a0e5368f153b4a8d0410dae4e.webp";